<template>
  <div class="row service-selector">
    <searchable-project-service-list
      :value="selectableServices"
      :disabled="disabled"
      :query="query"
      class="search-list"
      @queryChange="handleQueryChange"
      @select="handleSelectService"
      @addAll="handleClickAddAllButton"
    ></searchable-project-service-list>

    <selected-project-service-list
      :value="value"
      :disabled="disabled"
      class="selected-list"
      @remove="handleRemoveService"
      @removeAll="handleRemoveAllService"
    ></selected-project-service-list>
  </div>
</template>

<script>
import differenceWith from "ramda/src/differenceWith"
import { baanRueJaiClient } from "@/dependencies"
import SearchableProjectServiceList from "./SearchableProjectServiceList"
import SelectedProjectServiceList from "./SelectedProjectServiceList"

export default {
  components: {
    SearchableProjectServiceList,
    SelectedProjectServiceList,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    disabled: {
      type: null,
      default: undefined,
    },
  },
  data() {
    const allServices = []
    return {
      allServices,
      query: "",
    }
  },
  computed: {
    filteredAllServices() {
      if (!this.query || this.query.trim() === "") {
        return this.allServices
      }

      return this.allServices.filter((service) =>
        service.title.toLowerCase().includes(this.query.toLowerCase()),
      )
    },
    selectableServices() {
      return differenceWith(
        this.compareServiceFeature,
        this.filteredAllServices,
        this.value,
      )
    },
    showSearchList() {
      return !this.disabled
    },
    classList() {
      return { disabled: this.disabled }
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupData()
    },
    setupData() {
      this.setupServices()
    },
    async setupServices() {
      const { features } = await this.fetchData()

      const newFeatures = features
        .filter((feature) => !feature.disable)
        .map((feature) => {
          const { id, title, icon_url: icon } = feature

          return {
            id,
            icon,
            title,
          }
        })

      this.allServices = newFeatures
    },
    async fetchData() {
      const response = await baanRueJaiClient.admin.juristicFeature.list()

      return response.data.result
    },
    compareServiceFeature(service, service2) {
      return service.id === service2.id
    },
    handleSelectService(service) {
      this.updateInput([...this.value, service])
    },
    async handleClickAddAllButton() {
      if (this.selectableServices.length > 0) {
        const updatedServices = [...this.value, ...this.selectableServices]

        this.updateInput(updatedServices)
      }
    },
    handleRemoveService(service) {
      this.updateInput(this.value.filter(({ id }) => service.id !== id))
    },
    handleRemoveAllService() {
      // eslint-disable-next-line no-alert
      if (!window.confirm("คุณต้องการลบรายการบริการใช่หรือไม่")) {
        return
      }

      this.updateInput([])
    },
    updateInput(value) {
      this.$emit("input", value)
    },
    handleQueryChange(value) {
      this.query = value
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.service-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;

  > .search-list {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  > .selected-list {
    border-left-width: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
